import React from 'react';
import { classes } from './GroupTitleLink.st.css';
import { ApiTypes } from '@wix/social-groups-api/dist/src/types';

interface GroupTitleLinkProps {
  groupUrl: string;
  title: ApiTypes.v1.GroupResponse['details']['title'];
}

export const GroupTitleLink: React.FC<GroupTitleLinkProps> = ({
  groupUrl,
  title,
}) => {
  return (
    <a data-hook="title-link" className={classes.link} href={groupUrl}>
      {title}
    </a>
  );
};
